<template>
  <div v-if="true || $auth.check()">
    <v-navigation-drawer disable-resize-watcher v-model="drawer" temporary app width="300">
      <template v-slot:prepend>
        <v-list-item link>
          <v-list-item-avatar>
            <v-icon large>mdi-account-circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{current_user_employee_name}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-sheet>
        <v-list dense nav expand>
          <template v-for="(link,i) in links.filter(el => el.roles.includes(current_user_role_name))">
            <v-list-group
              :value="link.disabled ? false : true"
              :disabled="link.disabled"
              color="red"
              v-if="link.children"
              :key="i"
              :prepend-icon="link.icon"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-title>{{link.text}}</v-list-item-title>
              </template>
              <v-list-item
                v-for="(lk, idx) in link.children.filter(el => el.roles.includes(current_user_role_name))"
                :disabled="lk.disabled"
                :key="idx+lk.to"
                link
                :to="lk.to"
              >
                <v-list-item-icon>
                  <v-icon >{{lk.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{lk.text}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-if="link.to"
              :key="i"
              :to="link.to"
              color="red"
            >
              <v-list-item-icon>
                <v-icon >{{link.icon}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{link.text}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-sheet>
      <template v-slot:append>
        <v-list-item link to="/logout">
          <v-list-item-icon>
            <v-icon color="red">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="red--text">Sair</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { drawer } from "@/router/links";

export default {
  name: 'Drawer01',
  data() {
    return {
      links: drawer,
    };
  },
  computed: {
    drawer: {
      get() {
        return this.$store.getters["App/getDrawer"];
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    ...mapState({
      profile: state=>state.User.user,
    })
    ,
  },
  mounted () {
    this.setLinks()
  },
  methods: {
    setLinks(){
      let links = []
      if(this.current_user_role_name){
        const ROLE = this.current_user_role_name
        this.links.forEach(el => {
          if (el.roles && el.roles.length){
            if ( el.roles.includes(ROLE) ) {
              if ( el.children && el.children.length ){
                let c = el.children.filter(child => child.roles.includes(ROLE))
                links.push({...el, children: c})
              } else{
                links.push(el)
              }
            }
          } else {
            links.push(el)
          }
        });
        this.links = [...links]
      }
    },
    ...mapMutations({
      setDrawer: "App/setDrawer"
    })
  },
  // watch: {
  //   profile(nv,ov) {
  //     if (nv){
  //       //this.setLinks()
  //     } else if (nv == false){
  
  //     }
  //   }
  // },
};
</script>